import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { ConfigsStorage } from '@storage/configs.storage';

declare var $: any;
@Component({
  selector: 'app-prelogin-layout',
  templateUrl: './prelogin-layout.component.html',
})
export class PreloginLayoutComponent implements OnInit {
  hostName: string = window.location.hostname;
  isBrandHeader: boolean;
  logo: string;
  logoNavigateUrl: string = '/home';

  constructor(public configsStorage: ConfigsStorage) {}

  ngOnInit(): void {
    this.getDomainConfigs();
  }

  ngAfterViewInit(): void {
    if (!this.configsStorage.isDssSuiteEnable()) {
      $('#brand-background').addClass('onpremise');
    }
  }

  getDomainConfigs(): void {
    this.isBrandHeader = environment.brand_header;
    if (this.isBrandHeader) {
      if (environment.logo && environment.logo !== '') {
        this.logo = environment.logo;
        this.logoNavigateUrl = '/login';
      }
    }

    if (environment.background_image && environment.background_image !== '') {
      $('#brand-background').css('background', 'url(' + environment.background_image + ') center/cover no-repeat');
    }
  }

  navigateTo(route: string): void {
    window.location.href = route;
  }
}
